import styled from 'styled-components';
import theme from '../../styles/defaultTheme';

export const Container = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;

    padding: 32px;
    border-bottom: ${({ hasBorder }) => (hasBorder ? '1px solid #CCCCCC' : 'none')};

    @media screen and (max-width: 450px) {
        flex-direction: column;
    }

    .actual-page {
        color: ${(props) => props.theme.black} !important;
        font-size: ${theme.font.size20};
        font-weight: bold;
    }
`;

export const PagesList = styled.div`
    display: flex;
    align-items: center;

    .divider {
        width: 6px;
        height: 6px;
        background: ${(props) => props.theme.orange};
        border-radius: 50%;
        margin: 0 10px;
    }

    .page-name {
        color: ${(props) => props.theme.black};
        font-size: ${theme.font.size14};
    }
`;

export const BreadcrumbContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;

    width: 60%;

    .client-title {
        font-size: ${theme.font.size14};
        line-height: 24px;
    }

    .client-title, .active-contract-name {
        color: ${(props) => props.theme.grey};
    }

    .active-contract-name {
        font-size: ${theme.font.size24};
        line-height: 45px;
    }
`;

export const ContractContainer = styled.div`
    display: flex;
    flex-direction: column;  
    text-align: right;
    color: ${(props) => props.theme.blue};
    font-size: ${theme.font.size14};
`;
